module.exports = __webpack_public_path__ + "img/Tg(blue).60f62593.svg";